import { ArrowRight } from "lucide-react";

const PRODUCTS = [
  {
    id: 1,
    name: "Audífonos TWS + Traductor",
    description: "Audífonos intraurales inalámbricos que también funcionan como traductor de idiomas en tiempo real. Sonido nítido, ajuste cómodo y batería de larga duración.",
    price: "C$ 732",
    priceIsConsult: false,
    features: ["True Wireless", "Traductor en tiempo real", "Estuche de carga", "Sonido HD"],
    image: "/images/product1.jpg",
    tag: "Nuevo",
    tagColor: "bg-[#FFE4E8] text-[#E65B78]",
  },
  {
    id: 2,
    name: "Cascos Bluetooth Awei",
    description: "Cascos over-ear con almohadillas acolchadas de gran comodidad. Sonido envolvente de alta fidelidad. Compatible con cualquier dispositivo vía Bluetooth.",
    price: "C$ 657",
    priceIsConsult: false,
    features: ["Bluetooth", "Over-Ear", "Alta Fidelidad"],
    image: "/images/product2.jpg",
    tag: "Popular",
    tagColor: "bg-gray-100 text-gray-700",
  },
  {
    id: 3,
    name: "Parlante Bluetooth KiBroad",
    description: "Parlante portátil compacto con luces RGB, sonido potente y gancho para colgar. Resistente y fácil de llevar a donde vayas.",
    price: "C$ 506",
    priceIsConsult: false,
    features: ["Luces RGB", "Portátil", "Bluetooth"],
    image: "/images/product3.jpg",
    tag: "Audio",
    tagColor: "bg-purple-100 text-purple-700",
  },
  {
    id: 4,
    name: "Audífonos Bluetooth IP39",
    description: "Audífonos inalámbricos de alta calidad con sonido envolvente. Diseño ergonómico cómodo para uso prolongado. Compatible con cualquier dispositivo.",
    price: "Consultar precio",
    priceIsConsult: true,
    features: ["Bluetooth Wireless", "Sonido HD", "Diseño ergonómico"],
    image: "/images/product4.png",
    tag: "Disponible",
    tagColor: "bg-green-100 text-green-700",
  },
  {
    id: 5,
    name: "Cámara de Vigilancia WiFi",
    description: "Cámara de seguridad 4K con seguimiento automático y monitoreo 24 horas. Compatible con Android e iOS. Audio bidireccional integrado.",
    price: "C$ 2,202",
    priceIsConsult: false,
    features: ["WiFi 4K", "Monitoreo 24 HRS", "Android e iOS"],
    image: "/images/product5.png",
    tag: "Seguridad",
    tagColor: "bg-blue-100 text-blue-700",
  },
  {
    id: 6,
    name: "Parlante Bluetooth con Micrófono",
    description: "Parlante portátil con micrófono incluido. Ideal para karaoke y reuniones. Conectividad USB, Bluetooth y radio FM.",
    price: "C$ 441",
    priceIsConsult: false,
    features: ["USB + Bluetooth", "Radio FM", "Micrófono"],
    image: "/images/product6.png",
    tag: "Audio",
    tagColor: "bg-purple-100 text-purple-700",
  },
  {
    id: 7,
    name: "Andowl 5G Smart TV BOX Q-5G",
    description: "Transforma tu TV normal en un Smart TV inteligente. Incluye control remoto, adaptador de corriente y cable HDMI. Conectividad WiFi 5G.",
    price: "C$ 1,500",
    priceIsConsult: false,
    features: ["WiFi 5G", "Control remoto", "Cable HDMI incluido"],
    image: "/images/product7.png",
    tag: "Smart TV",
    tagColor: "bg-[#FFE4E8] text-[#E65B78]",
  },
];

export default function ProductsSection() {
  return (
    <section id="productos" className="py-20 md:py-28 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#E65B78] mb-3">
            Tienda
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#111111] mb-4">
            Accesorios Electrónicos
          </h2>
          <p className="text-base md:text-lg text-[#5C5C5C] max-w-xl mx-auto">
            Productos electrónicos de calidad disponibles en nuestra tienda física en Altamira, Managua.
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {PRODUCTS.map((product) => (
            <div
              key={product.id}
              data-testid={`product-card-${product.id}`}
              className="bg-white rounded-3xl overflow-hidden shadow-sm border border-gray-100 card-hover group"
            >
              {/* Product Image */}
              <div className="relative overflow-hidden bg-gray-50 h-64">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-contain p-4 group-hover:scale-105 transition-transform duration-300"
                />
                {/* Tag */}
                <span className={`absolute top-4 left-4 text-xs font-bold px-3 py-1.5 rounded-full ${product.tagColor}`}>
                  {product.tag}
                </span>
              </div>

              {/* Product Info */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-[#111111] mb-2">{product.name}</h3>
                <p className="text-[#5C5C5C] text-sm leading-relaxed mb-4">{product.description}</p>

                {/* Features */}
                <div className="flex flex-wrap gap-2 mb-5">
                  {product.features.map((f) => (
                    <span key={f} className="text-xs font-semibold bg-[#FFE4E8] text-[#E65B78] px-3 py-1 rounded-full">
                      {f}
                    </span>
                  ))}
                </div>

                {/* Price + CTA */}
                <div className="flex items-center justify-between">
                  <span className={`font-black text-xl ${product.priceIsConsult ? "text-[#5C5C5C] text-base" : "text-[#E65B78]"}`}>
                    {product.price}
                  </span>
                  <a
                    href={`https://wa.me/50589984547?text=Hola%20Printacce%2C%20me%20interesa%20${encodeURIComponent(product.name)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`product-whatsapp-${product.id}`}
                    className="inline-flex items-center gap-1.5 bg-[#E65B78] hover:bg-[#D44B66] text-white text-sm font-bold px-4 py-2 rounded-full transition-all duration-200"
                  >
                    Consultar
                    <ArrowRight size={14} />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-[#5C5C5C] text-sm mb-4">
            ¿Buscas otro accesorio? Consultanos directamente.
          </p>
          <a
            href="https://wa.me/50589984547?text=Hola%20Printacce%2C%20estoy%20buscando%20un%20accesorio%20electr%C3%B3nico"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="products-consult-btn"
            className="inline-flex items-center gap-2 bg-[#E65B78] hover:bg-[#D44B66] text-white font-bold px-7 py-3.5 rounded-full transition-all duration-200 shadow-md hover:shadow-lg"
          >
            Ver más productos por WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
